import { NamedProperty } from "sprint-common-web";

import { DeliveryEndpointLookupResponse } from "../api/orders-api/delivery-endpoint/GetDeliveryEndpointsLookupResponse";
import { DistributionList } from "../data/lookup-data-providers/DistributionListsDataProvider";
import { DeliveryEndpointType } from "./DeliveryEndpointType";

export interface DeliveryEndpoint {
    id: string;
    name: string;
    integrator: NamedProperty;
    type: DeliveryEndpointType;
    details: DeliveryEndpointDetails;
}

export type DeliveryEndpointDetails =
    | SmartjogDeliveryEndpointDetails
    | AsperaDeliveryEndpointDetails
    | SigniantDeliveryEndpointDetails;

export interface SmartjogDeliveryEndpointDetails {
    type: DeliveryEndpointType.Smartjog;
    distributionLists: DistributionList[];
}

export interface SigniantDeliveryEndpointDetails {
    type: DeliveryEndpointType.Signiant;
    destinationStorageProfile: NamedProperty;
    distributionEmail: string;
}

export interface AsperaDeliveryEndpointDetails {
    type: DeliveryEndpointType.Aspera;
    url: string;
    user: string;
    ssmPrivateKeyName: string;
}

export type DeliveryEndpointReference = NamedProperty;

export const mapToDeliveryEndpoint = (response: DeliveryEndpointLookupResponse): DeliveryEndpoint => {
    switch (response.type) {
        case DeliveryEndpointType.Smartjog:
            return {
                id: response.id,
                name: response.name,
                type: response.type,
                integrator: {
                    id: response.integrator.id,
                    name: response.integrator.name
                },
                details: {
                    distributionLists: response.distributionLists.map((item) => ({ id: item.id, name: item.name })),
                    type: DeliveryEndpointType.Smartjog
                }
            };
        case DeliveryEndpointType.Aspera:
            return {
                id: response.id,
                name: response.name,
                type: response.type,
                integrator: {
                    id: response.integrator.id,
                    name: response.integrator.name
                },
                details: {
                    type: DeliveryEndpointType.Aspera,
                    url: response.url,
                    user: response.user,
                    ssmPrivateKeyName: response.ssmPrivateKeyName
                }
            };
        case DeliveryEndpointType.Signiant:
            return {
                id: response.id,
                name: response.name,
                type: response.type,
                integrator: {
                    id: response.integrator.id,
                    name: response.integrator.name
                },
                details: {
                    distributionEmail: response.distributionEmail,
                    destinationStorageProfile: response.destinationStorageProfile,
                    type: DeliveryEndpointType.Signiant
                }
            };
    }
};
